// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SubStories__subStories___4bxhl{display:flex;flex-direction:column}.SubStories__substoriesLoader___2RhWA{height:calc(100% - 56px);width:100%;position:relative}.SubStories__substoriesLoader___2RhWA>div{width:32px;height:32px;position:absolute;top:50%;left:50%}\n", ""]);
// Exports
exports.locals = {
	"subStories": "SubStories__subStories___4bxhl",
	"substoriesLoader": "SubStories__substoriesLoader___2RhWA"
};
module.exports = exports;
